import { render, staticRenderFns } from "./StPrivacySettings.vue?vue&type=template&id=7ef7ff1a&scoped=true"
import script from "./StPrivacySettings.vue?vue&type=script&lang=ts"
export * from "./StPrivacySettings.vue?vue&type=script&lang=ts"
import style0 from "./StPrivacySettings.vue?vue&type=style&index=0&id=7ef7ff1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7ff1a",
  null
  
)

export default component.exports